import { Checkbox, Modal, Radio, Space } from 'antd';
import { useAuth, setUserSetting, clearSavedHolderFilter } from './store';
import { useStationFilter } from '../SearchStation/store';
import References from '../../helpers/Reference';

export const UserSettingsModal = ({ open, onClose }) => {
    const { userSettings } = useAuth();

    const onHolderFilterChange = (event) => {
        const checked = event.target.checked;

        if (checked) {
            const currentAreas = useStationFilter.getState().areas || [];
            setUserSetting('setting_holder_filter', 1);
            setUserSetting('setting_holder_filter_areas', [...currentAreas]);
            return;
        }

        clearSavedHolderFilter();
    };

    const onWindUnitChange = (event) => {
        setUserSetting('setting_wind_unit', event.target.value);
    };

    const onPressureUnitChange = (event) => {
        setUserSetting('setting_pressure_unit', event.target.value);
    };

    const catalog = References.settingsCatalog || {};
    const windMeta = catalog.setting_wind_unit || {};
    const pressureMeta = catalog.setting_pressure_unit || {};

    return (
        <Modal
            title="Настройки"
            open={open}
            onCancel={onClose}
            footer={[]}
        >
            <div className="p-2">
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <Checkbox
                        checked={Number(userSettings?.setting_holder_filter) === 1}
                        onChange={onHolderFilterChange}
                    >
                        Сохранять фильтр по держателю поста
                    </Checkbox>

                    <div>
                        <div style={{ marginBottom: 8, fontWeight: 600 }}>{windMeta.label || References.dictionary.settings_title.wind}</div>
                        <Radio.Group
                            value={userSettings?.setting_wind_unit || windMeta.default || 'rumbs'}
                            onChange={onWindUnitChange}
                        >
                            <Space direction="vertical">
                                {(windMeta.options || []).map(opt => (
                                    <Radio key={opt.value} value={opt.value}>{opt.label}</Radio>
                                ))}
                            </Space>
                        </Radio.Group>
                    </div>

                    <div>
                        <div style={{ marginBottom: 8, fontWeight: 600 }}>{pressureMeta.label || References.dictionary.settings_title.pressure}</div>
                        <Radio.Group
                            value={userSettings?.setting_pressure_unit || pressureMeta.default || 'gPa'}
                            onChange={onPressureUnitChange}
                        >
                            <Space direction="vertical">
                                {(pressureMeta.options || []).map(opt => (
                                    <Radio key={opt.value} value={opt.value}>{opt.label}</Radio>
                                ))}
                            </Space>
                        </Radio.Group>
                    </div>
                </Space>
            </div>
        </Modal>
    );
};
